/**
 * Accordion Onclick function
 */
function stickyAddToCart() {
    var addToCartButton =  $('.js-product-add-to-cart-wrap');

    $(window).scroll(function() {
        if ($(this).scrollTop() >= addToCartButton.offset().top) {
            $('.js-sticky-add-to-cart').addClass('is-fixed');
            $('body').addClass('sticky-active');
        } else {
            $('.js-sticky-add-to-cart').removeClass('is-fixed');
            $('body').removeClass('sticky-active');
        }
    });
}

/**
 * Initialize the function
 */
function init() {
    stickyAddToCart();
}

export default {
    init
};
